import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentArrowReset = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  (
    { fillColor = '#212121', ...props }: { fillColor?: string } & SvgProps,
    ref
  ) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      ref={ref}
      {...props}
    >
      <Path
        d='M7.207 2.543a1 1 0 010 1.414L5.414 5.75h7.836a8 8 0 11-8 8 1 1 0 112 0 6 6 0 106-6H5.414l1.793 1.793a1 1 0 01-1.414 1.414l-3.5-3.5a1 1 0 010-1.414l3.5-3.5a1 1 0 011.414 0z'
        fill={fillColor}
        transform='scale(-1 1) translate(-24,0)'
      />
    </Svg>
  )
)

FluentArrowReset.displayName = 'FluentArrowReset'

export default FluentArrowReset
